import Money from "./Money";

export default class PriceRange {
  maxVariantPrice?: Money;
  minVariantPrice?: Money;

  constructor(response?: any) {
    if (response != null) {
      this.maxVariantPrice = new Money(response.maxVariantPrice);
      this.minVariantPrice = new Money(response.minVariantPrice);
    }
  }
}
